import { Button } from '@heroui/react';
import { motion } from 'framer-motion';
import { FaTriangleExclamation, FaArrowRight } from 'react-icons/fa6';

/* ---- Reconnect warning banner — surfaces channels that need re-auth ---- */
export default function ReconnectBanner({ count, onGoToChannels }) {
	return (
		<motion.div
			initial={{ opacity: 0, y: -10 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ type: 'spring', stiffness: 240, damping: 26 }}
			className="relative overflow-hidden rounded-3xl border border-amber-200 bg-amber-50 px-5 py-4 md:px-6 mb-6"
		>
			<div className="relative flex flex-col sm:flex-row sm:items-center justify-between gap-3">
				<div className="flex items-start gap-3">
					<div className="mt-0.5 flex-none w-9 h-9 rounded-xl bg-amber-100 text-amber-600 grid place-items-center">
						<FaTriangleExclamation size={16} />
					</div>
					<div>
						<h2 className="m-0 text-[15px] font-semibold text-amber-900">
							{count === 1 ? '1 channel needs reconnection' : `${count} channels need reconnection`}
						</h2>
						<p className="mt-0.5 text-[13px] text-amber-700/90 leading-snug">
							Access expired. Reconnect to keep dubbing and publishing to {count === 1 ? 'this channel' : 'these channels'}.
						</p>
					</div>
				</div>
				<Button
					size="md"
					radius="full"
					color="warning"
					className="font-semibold text-white self-start sm:self-auto flex-none"
					endContent={<FaArrowRight size={13} />}
					onPress={onGoToChannels}
				>
					Go to channels
				</Button>
			</div>
		</motion.div>
	);
}
